import { render, staticRenderFns } from "./ContainerFluid.vue?vue&type=template&id=210f864e"
import script from "./ContainerFluid.vue?vue&type=script&lang=ts"
export * from "./ContainerFluid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports